import cn from 'classname';
import moment from 'moment';
import _isUndefined from 'lodash/isUndefined';
import React from 'react';
import './Cell.less';

const Cell = (props) => {
	const { row_number, data, setActiveRow, activeRowNumber, column, rows } = props;
	const { past_approved_count, past_total_count } = getPast3DaysConversionCounts(column, rows, row_number);
	const approved_count = Number(data[`approved_${column}`]) || 0;
	const total_count = Number(data[`total_${column}`]) || null;
	const past3DaysApprovalRatio = Math.round(100 * past_approved_count / past_total_count );
	const currentApproveRatio = Math.round(100 * approved_count / total_count);

	if (approved_count < 10 && props.isToggledStartFrom10Approves) {
		return (
			<div
				className={cn({ 'table_cell': true, 'active': row_number === activeRowNumber })}
				onMouseEnter={setActiveRow.bind(null, row_number)}
				onMouseLeave={setActiveRow.bind(null, -1)}
			>
			</div>
		);
	}

	return (
		<div
			className={cn({ 'table_cell': true, 'active': row_number === activeRowNumber })}
			onMouseEnter={setActiveRow.bind(null, row_number)}
			onMouseLeave={setActiveRow.bind(null, -1)}
		>
			<div><b>{Number(data[`total_${column}`]) || 0}</b></div>
			<div className="approved-number"><i>{Number(data[`approved_${column}`]) || 0}</i></div>
			<div>
				{	past3DaysApprovalRatio ? <span className="old"> {past3DaysApprovalRatio} % </span> : <span>x</span>} /
				{	currentApproveRatio && <span className="new"> {currentApproveRatio} % </span> }
			</div>
			{
				past_total_count &&
				<div className={cn({
					'traffic-change-arrow': true,
					'increased-traffic': approved_count > past_approved_count/3,
					'decreased-traffic': approved_count < past_approved_count/3
				})}>
					⬅
				</div>
			}
		</div>
	);
};

function getPast3DaysConversionCounts(column, rows, row_number) {
	let N = 3;
	let counts = { past_approved_count: 0, past_total_count: 0 };
	while (N) {
		const date = moment(column).subtract(N--, 'days').format('YYYY-MM-DD');
		if (
			_isUndefined(rows[row_number][`approved_${date}`]) || _isUndefined(rows[row_number][`total_${date}`])
		) {
			counts = { past_approved_count: null, past_total_count: null };
			break;
		}
		counts.past_approved_count += Number(rows[row_number][`approved_${date}`]);
		counts.past_total_count += Number(rows[row_number][`total_${date}`]);
	}
	return counts;
}

export default Cell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-drop/Cell.js